/**
 * API Headers Utility
 * Helper functions to add tenant subdomain headers to API requests
 */

/**
 * Extract subdomain from current hostname
 */
export function getSubdomain(): string | null {
  if (typeof window === 'undefined') return null;

  const hostname = window.location.hostname;
  const subdomainMatch = hostname.match(/^([^.]+)\./);

  if (subdomainMatch && subdomainMatch[1] && subdomainMatch[1] !== 'www') {
    return subdomainMatch[1];
  }

  return null;
}

/**
 * Get headers with subdomain information for API requests
 * This allows backend to identify which tenant database to use
 */
export function getApiHeaders(additionalHeaders: HeadersInit = {}): HeadersInit {
  const subdomain = getSubdomain();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(additionalHeaders as Record<string, string>),
  };

  // Add subdomain header if available
  if (subdomain) {
    headers['x-tenant-subdomain'] = subdomain;
  }

  // Add Origin header for backend to extract subdomain as fallback
  if (typeof window !== 'undefined') {
    headers['Origin'] = window.location.origin;
  }

  return headers as HeadersInit;
}

/**
 * Get headers with authorization token and subdomain
 */
export function getAuthHeaders(additionalHeaders: HeadersInit = {}): HeadersInit {
  const token = localStorage.getItem('admin_token');

  const headers = getApiHeaders(additionalHeaders) as Record<string, string>;

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers as HeadersInit;
}
